import cs from 'classnames';
import React from 'react';
import { SummaryHeader } from 'shared/summary/SummaryHeader';
import { SummarySection } from 'shared/summary/SummarySection';
import { slugs, useTuitionSteps } from 'tuition/steps';
import { TuitionApplicationFragment, TuitionErrorField } from '../../generated.graphql';
import { additionalErrorFilter } from '../additional/AdditionalInfo';
import { TuitionSummaryField } from './TuitionSummaryField';


interface Props {
  application: TuitionApplicationFragment
}


export const AdditionalSummary = ({ application }: Props) => {
  const steps = useTuitionSteps({slug: slugs.additionalInfo});
  const errors = application?.validationErrors.filter(additionalErrorFilter) || [];
  const isInvalid = errors.length > 0;
  return (
    <SummarySection>
      <SummaryHeader step={steps.this} className={cs(isInvalid && 'text-danger')}>Additional Information</SummaryHeader>
      <TuitionSummaryField data={application} field={TuitionErrorField.Notes} errors={errors} label="Comments" />
    </SummarySection>
  );
}
